<template>
        
    <div class="card">
        <div class="card-body">

            <h4 
                class="card-title"
                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''">
                {{ $t('view.license_no') }}
            </h4>
            <div class="col-12 pd-0" style="padding:0">
                <input 
                    id="slug"
                    class="form-control text-lowercase" 
                    type="text" 
                    v-model="row.license_no"
                    @keydown.space.prevent 
                    @paste="onPaste"
                    v-on:input="onChange">
            </div>
        </div>
    </div>
        
</template>

<script>
export default {
    namme: 'CardLicenseNo',
    props: [
        'license_no'
    ],
    data(){
        return {
            row: {
                license_no: this.$props.license_no
            },
        }
    },
    mounted() {},
    methods: {

        onChange(){
            const data = {
                license_no: this.row.license_no
            }
            this.$emit('licenseNoChange', data);
        },
        onPaste(){
            let str = this.row.license_no;
            this.preventSpace(str);
        },
        preventSpace(str){
            if(!str) {
                let str = this.row.license_no;
                this.row.license_no = str.replace(/\s+/g, '-');
            } else {
                this.row.license_no = str.replace(/\s+/g, '-');
            }
        },

    }
}
</script>
